import script from "./CustomFieldModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldModal.vue?vue&type=style&index=0&id=64df0b97&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64df0b97"]])

export default __exports__